
import LandingPage from "./pages/user"
import { RequireAuth } from "./context/auth-context"
import Userlayout from "./layouts/user-layout"
import { Children } from "react"
import AdminLayout from "./layouts/admin-layout"
import Settings from "./pages/admin/settings"
import Dashboard from "./pages/admin"
import Users from "./pages/admin/users"
import Input from "./pages/admin/input"
import Budget from "./pages/admin/budget"
import Bills from "./pages/user/bills/bills"
import CashbookPage from "./pages/user/cashbook/cashbook"
import CustomerPage from "./pages/user/customers/customer"
import SupplierManagement from "./pages/user/suppliers/suppliers"
import Reports from "./pages/user/reports"
import Dashboards from "./pages/user/dashboard"
import Journal from "./pages/user/journal"
import Transactions from "./pages/user/cashbook/trans"
const routes = [
    {
        path: "/",
        element: <RequireAuth><Userlayout /></RequireAuth>,
        children:[
            {
                path: "/",
                element: <Dashboards />,
            },
            {
                path: "/budget",
                element: <LandingPage />,
            },
            {
                path: "/bills",
                element: <Bills />,
            },
            {
                path: "/cashbook",
                element: <CashbookPage />,
            },
            {
                path: "/customers",
                element: <CustomerPage />,
            },
            {
                path: "/suppliers",
                element: <SupplierManagement />,
            },
            {
                path: "/reports",
                element: <Reports />,
            },
            {
                path: "/journal",
                element: <Journal />,
            },
            {
                path: "/transactions",
                element: <Transactions />,
            },
        ]
    },
    {
        path: "/admin",
        element: <RequireAuth><AdminLayout /></RequireAuth>,
        children:[
            {
                path: "/admin",
                element: <Dashboard />,
            },
            {
                path: "/admin/settings",
                element: <Settings />,
            },
            {
                path: "/admin/users",
                element: <Users />,
            },
            {
                path: "/admin/input",
                element: <Input />,
            },
            {
                path: "/admin/budget",
                element: <Budget />,
            },
        ]
    },
]

export default routes